import { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from 'app/store/userSlice';
import Orders from 'app/main/apps/e-commerce/orders/Orders';
import VasListGate from 'app/main/apps/vas/list/VasListGate';
import StaffListPage from './StaffListPage';
import { shouldUseStaffList } from './staffListConfig';

// Keep the legacy tab view out of the orders/quotes/rfqs gate bundle (only warehouse hits it).
const OrdersTabView = lazy(() => import('app/main/apps/e-commerce/orders/ordersTab/OrdersTabView'));

/**
 * Internal users get the new list page when that list type has opted in.
 * Customer and supplier portals keep the existing page; container shipments keep the tabbed
 * OrdersTabView for roles outside the staff allowlist (warehouse). A VAS-only login on Orders gets
 * the VAS list (VasListGate); everyone else the existing Orders page.
 */
function StaffListGate(props) {
  const user = useSelector(selectUser);
  if (shouldUseStaffList(user, props.type)) {
    return <StaffListPage {...props} />;
  }
  if (props.type === 'container') {
    return (
      <Suspense fallback={null}>
        <OrdersTabView {...props} />
      </Suspense>
    );
  }
  return <VasListGate {...props} fallback={<Orders {...props} />} />;
}

export default StaffListGate;
